import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CustomerService } from '../../services/customers.service';
import { Customer } from '../../models/customer';
import { ScheduleService } from '../../services/schedule.service';
import { ScheduleSerieService } from '../../services/scheduleserie.service';
import { Schedule } from '../../models/schedule';
import { ScheduleSerie } from '../../models/scheduleSerie';
import { ScheduleTitleService } from '../../services/scheduleTitle.service';
import { ScheduleTitle } from '../../models/scheduleTitle';
import { DepartmentService } from '../../services/department.service';
import { ProvinciaService } from '../../services/provincia.service';
import { CustomerWorkScheduleService } from '../../services/customerWorkSchedule.service';
import { Department } from '../../models/department';
import { Provincia } from '../../models/provincia';
import { CityService } from '../../services/city.service';
import { City } from '../../models/city';
import { SelectItem, Header } from 'primeng/api';
import { DropdownService } from '../../services/dropdownService';
import { CustomerSchedule } from '../../models/customerSchedule';
import * as XLSX from 'xlsx';
import { CategoryService } from '../../services/category.service';
import { Category } from '../../models/category';
import { TemplateEmailService } from '../../services/templateEmail.service';
import { EmailService } from '../../services/email.service';
import { TemplateEmail } from '../../models/templateEmail';
import { NameValue } from '../../models/nameValue';
import { AgendaProConst } from '../../models/constantesAgendaPro';
import { CampaingService } from '../../services/campaing.service';
import { SubscriberService } from '../../services/subscriber.service';
import { Subscriber } from '../../models/subscriber';
import { CountryService } from '../../services/country.service';
import { Country } from '../../models/country';
import { FestiveService } from '../../services/festive.service';
import { Festive } from '../../models/festive';
declare var $: any;
declare var google: any;
type AOA = any[][];


@Component({
  selector: 'app-agenda-co',
  templateUrl: './agenda-co.component.html',
  styleUrls: ['./agenda-co.component.css'],
  providers: [SubscriberService, CustomerService, ScheduleTitleService, ScheduleService, ScheduleSerieService, DepartmentService, ProvinciaService, CustomerWorkScheduleService, CountryService, CityService, FestiveService, CategoryService, CampaingService, DropdownService, TemplateEmailService, EmailService]

})
export class AgendaCoComponent implements OnInit {

  public template: TemplateEmail;
  public variables: string[] = [];
  public variables1: NameValue;
  public listVariables: NameValue[] = [];
  public customer: Customer;
  public subscriber: Subscriber;
  public schedule: Schedule;
  public scheduleTitle: ScheduleTitle[] = [];
  public scheduleSerie: ScheduleSerie[] = [];
  invalidDates: Array<Date> = [];
  public department: Department;
  public provincia: Provincia;
  public listDepartments: Department[];
  public listProvincias: Department[];
  public listCities: City[];
  public city: City;
  public country: Country;
  public listfestives: Festive[];
  public festive: Festive;
  public disabledDates: any[];
  public minDate: Date;
  public maxDate: Date;
  public dropdownProvincias: SelectItem[];
  public dropdownDepartments: SelectItem[];
  public dropdownCities: SelectItem[];
  public citySelected: City;
  public category: Category;
  public listCustomerWorkSchedule: CustomerSchedule[];
  public dropdownCustomerSchedule: SelectItem[];
  public validateLocation: boolean;
  public validateSchedule: boolean;
  public validateDate: boolean;
  public title1: string;
  public title2: string;
  public title3: string;
  public title4: string;
  public title5: string;
  public title6: string;
  public title7: string;
  public title8: string;
  public title9: string;
  public title10: string;
  public title11: string;
  public title12: string;
  public title13: string;
  public title14: string;
  public title15: string;
  public title16: string;
  public title17: string;
  public phone: string;
  public email: string;
  public identification: number;
  public tel: number;
  public telMovil: number;
  public chat: string;
  public whatsapp: string;
  public logo: string;
  public urlpolicy: string;
  public urltyc: string;
  public componentForm: any;
  public placeSearch: any;
  public autocomplete: any;
  public lat: number;
  public ln: number;
  public view: boolean;
  arrayBuffer: any;
  file: File;
  data: any;
  first = 0;
  cols: any[];
  customerGeneral: string;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _customerService: CustomerService,
    private _subscriberService: SubscriberService,
    private _departmentService: DepartmentService,
    private _provinciaService: ProvinciaService,
    private _customerWorkScheduleService: CustomerWorkScheduleService,
    private _countryService: CountryService,
    private _cityService: CityService,
    private _festiveService: FestiveService,
    private _categoryService: CategoryService,
    private _dropdownService: DropdownService,
    private _scheduleService: ScheduleService,
    private _scheduleTitleService: ScheduleTitleService,
    private _scheduleSerieService: ScheduleSerieService,
    private _templateEmailService: TemplateEmailService,
    private _emailService: EmailService,
  ) {
    this.title1 = '';
    this.title2 = '';
    this.title3 = '';
    this.title4 = '';
    this.title5 = '';
    this.title6 = '';
    this.title7 = '';
    this.title8 = '';
    this.title9 = '';
    this.title10 = '';
    this.title11 = '';
    this.title12 = '';
    this.title13 = '';
    this.title14 = '';
    this.title15 = '';
    this.title16 = '';
    this.title17 = '';
    this.schedule = new Schedule();
    this.schedule.company = '';
    this.schedule.imei = '';
    this.schedule.quantity = 1;
    this.schedule.nroTicket = '';
    this.schedule.acceptE = false;
    this.schedule.acceptP = false;
    this.schedule.accountBilling = '';
    this.schedule.filePdf = '';
    this.schedule.process = 0;
    this.citySelected = new City();
    this.validateLocation = true;
    this.validateSchedule = false;
    this.validateDate = false;
    this.customer = new Customer();
    this.subscriber = new Subscriber();
    this.variables1 = new NameValue();
    this.chat = '';
    this.view = false;
    this.phone = '';
    this.email = '';
    this.urlpolicy = '';
    this.urltyc = '';
    this.customerGeneral = '';
    this.componentForm = {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'short_name',
      country: 'long_name',
      postal_code: 'short_name'
    };
    this.cols = [
      { field: 'id', header: 'ID' },
      { field: 'nit', header: 'Nit' },
      { field: 'datePurchase', header: 'Fecha' },
      { field: 'mark', header: 'Marca' },
      { field: 'model', header: 'Modelo' },
      { field: 'colour', header: 'Color' },
      { field: 'imei', header: 'Imei' },
      { field: 'cover', header: 'Tapa' },
      { field: 'battery', header: 'Bataria' },
      { field: 'loader', header: 'Cargador' },
      { field: 'memoryRemovable', header: 'Memoria' },
      { field: 'freeHand', header: 'Manos Libres' },
      { field: 'other', header: 'Otros' },
      { field: 'failure', header: 'Falla' },
    ];
    let todays = new Date();
    this.minDate = new Date();
    this.minDate.setDate(todays.getDate() + 2);
    this.maxDate = new Date();
    this.maxDate.setMonth(new Date().getMonth() + 2);
  }

  ngOnInit(): void {
    let customerId = '';
    this._route.params.forEach((params: Params) => {
      customerId = params['clienteAcronym'];
      //customerId = params['clienteName'];
      if (customerId != 'movistar.pe') {
        this.customerGeneral = 'NO';
      } else {
        this.customerGeneral = 'SI';
      }
    });

    if (customerId != undefined) {
      this.getCustomer(customerId);
    }
    this.getTemplateEmail();

  }
  searchByIdentification() {
    var identification = this.identification;
    this._scheduleService.getByCustomerIdentification(identification).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.schedule.email = response.object.email;
          this.tel = response.object.telephone;
          this.telMovil = response.object.celphone;
          this.schedule.address = response.object.address;
          this.schedule.name = response.object.nameComplete;
        } else {
          alert(response.message);
        }
      });
  }
  getFestive(countryid) {
    this._festiveService.getByCountryId(countryid).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.listfestives = response.object;
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getDateFestive() {
    let today = new Date();
    this.minDate = new Date();
    this.minDate.setDate(today.getDate() + 1);
    for (const hd of this.listfestives) {
      this.invalidDates.push(new Date(hd.date));
    }
  }

  getDatePickup() {
    let todays = new Date();
    this.minDate = new Date();
    if (this.customer.provincia == 1) {
      let result = this.citySelected.categoryDay != undefined ? this.citySelected.categoryDay : 2;
      this.minDate.setDate(todays.getDate() + result);
      this.maxDate = new Date();
      this.maxDate.setMonth(new Date().getMonth() + 2);
      if (this.schedule.departmentId != undefined || this.citySelected != undefined) {
        this.validateSchedule = true;
        this.validateDate = true;
      }
    } else {
      let result = this.citySelected.categoryDay != undefined ? this.citySelected.categoryDay : 3;
      this.minDate.setDate(todays.getDate() + result);
      this.maxDate = new Date();
      this.maxDate.setMonth(new Date().getMonth() + 2);
      if (this.schedule.departmentId != undefined || this.citySelected != undefined) {
        this.validateSchedule = true;
        this.validateDate = true;
      }
    }

  }

  getView() {
    if (this.customer.name != 'CLARO') {
      if (this.customer.name != 'CLARO - PERU') {
        if (this.customer.name != 'CLAROMOVIL') {
          if (this.customer.name != 'ETB') {
            if (this.customer.name != 'TIGO') {
              if (this.customer.name != 'TIGO - PANAMA') {
                if (this.customer.name != 'TIGO SALVADOR') {
                  if (this.customer.name != 'DIRECTV') {
                    this.view = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      this.view = false;
    }
  }

  getCustomer(name) {
    //this._customerService.getByName(name, false).subscribe(
    this._customerService.getByAcronym(name, true).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          const customerR = response.object;
          this.customer = customerR[0];
          this.getCustomerWorkSchedule(this.customer.id);
          this.phone = this.customer.foot1.replace(' {phone} ', ' ' + this.customer.phone).replace(' {email} ', ' ' + this.customer.email).replace(' {whatsapp} ', ' ' + this.customer.whatsapp);
          this.email = this.customer.foot2.replace(' {email} ', ' ' + this.customer.email).replace(' {phone} ', ' ' + this.customer.phone).replace(' {whatsapp} ', ' ' + this.customer.whatsapp);
          this.chat = this.customer.chat;
          this.whatsapp = 'https://wa.me/' + this.customer.whatsapp + '?text=Hola, quiero agendar la devolución de mis equipos';
          this.logo = 'https://wts.woden.com.co/agvirtual/assets/images/' + this.customer.id + '.jpg';
          this.urlpolicy = this.customer.urlPolicy;
          this.urltyc = this.customer.urlTyC;
          this.getCountry(this.customer.countryId);
          this.getFestive(this.customer.countryId);
          this.getScheduleTitle(this.customer.id);
          if (this.customer.provincia == 1) {
            this.getProvincia();
          } else {
            this.getDepartment();
          }
          this.getView();
          this.loadScript(this.chat);
          document.getElementById('footer1').innerHTML = this.phone;
          document.getElementById('footer2').innerHTML = this.email;
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  getSubscriber(code) {
    this.schedule = new Schedule();
    this.schedule.quantity = 1;
    this.citySelected = new City();
    this._subscriberService.getByCode(code).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.subscriber = response.object[0];
          if (this.subscriber != null) {
            this.schedule.name = String(this.subscriber.name);
            this.schedule.email = this.subscriber.email;
            this.tel = Number(this.subscriber.phone1);
            this.telMovil = Number(this.subscriber.phone2);
            this.schedule.address = this.subscriber.address;
            this.schedule.department = this.subscriber.department;
            this.schedule.city = this.subscriber.city;
            this.getDepartmentName(String(this.subscriber.department));
            this.validateLocation = true;
            this.validateDate = true;
            this.changeCity();
          }
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getScheduleTitle(customerid) {
    this._scheduleTitleService.getByCustomerId(customerid).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.scheduleTitle = response.object;
          this.setTitle(this.scheduleTitle);
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  setTitle(List: any[]) {
    for (const ld of this.scheduleTitle) {
      if (ld.number == 1) {
        this.title1 = ld.name;
      } else if (ld.number == 2) {
        this.title2 = ld.name;
      } else if (ld.number == 3) {
        this.title3 = ld.name;
      } else if (ld.number == 4) {
        this.title4 = ld.name;
      } else if (ld.number == 5) {
        this.title5 = ld.name;
      } else if (ld.number == 6) {
        this.title6 = ld.name;
      } else if (ld.number == 7) {
        this.title7 = ld.name;
      } else if (ld.number == 8) {
        this.title8 = ld.name;
      } else if (ld.number == 9) {
        this.title9 = ld.name;
      } else if (ld.number == 10) {
        this.title10 = ld.name;
      } else if (ld.number == 11) {
        this.title11 = ld.name;
      } else if (ld.number == 12) {
        this.title12 = ld.name;
      } else if (ld.number == 13) {
        this.title13 = ld.name;
      } else if (ld.number == 14) {
        this.title14 = ld.name;
      } else if (ld.number == 15) {
        this.title15 = ld.name;
      } else if (ld.number == 16) {
        this.title16 = ld.name;
      } else if (ld.number == 17) {
        this.title17 = ld.name;
      }
    }
    console.log(this.title1);
  }
  getCountry(id) {
    this._countryService.getById(id).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.country = response.object;
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getCountryCode1(code1) {
    this._countryService.getByCode1(code1).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.country = response.object;
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getDepartment() {
    this._departmentService.getByCountryId(this.customer.countryId, false).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.listDepartments = response.object;
          this.dropdownDepartments = this._dropdownService.generateDropdownIdSCode(this.listDepartments);
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  getDepartmentByProvincia(provinciaId) {
    this._departmentService.getByProvinciaId(this.customer.countryId, provinciaId, false).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.listDepartments = response.object;
          this.dropdownDepartments = this._dropdownService.generateDropdownIdSCode(this.listDepartments);
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getProvincia() {
    this._provinciaService.getByCountryId(this.customer.countryId, false).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.listProvincias = response.object;
          this.dropdownProvincias = this._dropdownService.generateDropdownIdSCode(this.listProvincias);
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getDepartmentName(name) {
    this._departmentService.getByName(name).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.department = response.object;
          this.schedule.departmentId = this.department.id;
          this.changeDepartment();
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  changeDepartment() {
    this.getCities(this.schedule.departmentId);
    this.getCityName(this.schedule.city);
  }
  changeProvincia() {
    this.getDepartmentByProvincia(this.schedule.provinciaId);
  }
  getCities(departmentId) {
    this._cityService.getByDepartmentId(departmentId, false).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.listCities = response.object;
          this.dropdownCities = this._dropdownService.generateDropdownEntitySCode(this.listCities);
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getCityName(name) {
    this._cityService.getByName(name).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.city = response.object[0];
          this.citySelected = this.city;
          if (this.schedule.departmentId != undefined || this.citySelected != undefined) {
            this.validateSchedule = true;
            this.validateDate = true;
          }
          else {
            this.validateSchedule = false;
            this.validateDate = false;
          }
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getProvinciaName(name) {
    this._cityService.getByName(name).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.city = response.object[0];
          this.citySelected = this.city;
          if (this.schedule.departmentId != undefined || this.citySelected != undefined) {
            this.validateSchedule = true;
            this.validateDate = true;
          }
          else {
            this.validateSchedule = false;
            this.validateDate = false;
          }
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  //Fin Anexar Provincias
  changeCity() {
    this.getDateFestive();
    this.getDatePickup();
    if (this.schedule.departmentId != undefined || this.citySelected != undefined) {
      this.validateSchedule = true;
      this.validateDate = true;
    }
  }
  getCategory() {
    this._categoryService.getById(this.citySelected.categoryId).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.category = response.object;
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getCustomerWorkSchedule(customerId) {
    this._customerWorkScheduleService.getByCustomerId(customerId).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.listCustomerWorkSchedule = response.object;
          this.generateDropdownCustomerSchudule();
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  generateDropdownCustomerSchudule() {
    this.dropdownCustomerSchedule = [];
    this.dropdownCustomerSchedule.push({ label: 'Seleccione', value: null });
    for (const hr of this.listCustomerWorkSchedule) {
      this.dropdownCustomerSchedule.push({ label: hr.workSchedule, value: hr.workScheduleId });
    }
  }
  changeAddress() {
    if (this.schedule.identification != undefined || this.schedule.name != undefined || this.schedule.email != undefined
      || this.schedule.address != undefined || this.schedule.phoneMobile != undefined) {
      this.getDateFestive();
      this.getDatePickup();
      this.validateLocation = true;

    }
  }
  createSchedule() {
    this.schedule.date = new Date();
    this.schedule.identification = String(this.identification);
    this.schedule.phone = String(this.tel);
    this.schedule.phoneMobile = String(this.telMovil);
    this.schedule.customerId = this.customer.id;
    this.schedule.cityId = this.citySelected.id;
    if (this.schedule.email == '' || this.schedule.email == undefined) {
      this.schedule.email = ' ';
    }
    this._scheduleService.create(this.schedule).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.schedule = response.object;
          this.schedule.date = new Date(this.schedule.date);
          this.schedule.datePickup = new Date(this.schedule.datePickup);
          setTimeout(() => {
            if (this.schedule.id != null) {
              if (this.customer.name.toUpperCase() === 'CLAROMOVIL') {
                this.scheduleSerie.forEach(sc => {
                  sc.scheduleId = this.schedule.id;
                  this._scheduleSerieService.create(sc).subscribe(
                    res => {
                      if (res.statusCode === '200 OK') {

                      } else {
                        console.log(res);
                      }
                    });
                });
              }
              if (this.customer.sendNotification === true) {
                this.variables.forEach(vr => {
                  if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.fecha) {
                    this.variables1.name = 'fecha';
                    this.variables1.value = this.schedule.date.toDateString();
                    this.listVariables.push(this.variables1);
                    this.variables1 = new NameValue();
                  } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.direccion) {
                    this.variables1.name = 'direccion';
                    this.variables1.value = String(this.schedule.address);
                    this.listVariables.push(this.variables1);
                    this.variables1 = new NameValue();
                  } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.correo) {
                    this.variables1.name = 'correo';
                    this.variables1.value = String(this.schedule.email);
                    this.listVariables.push(this.variables1);
                    this.variables1 = new NameValue();
                  } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.identificacion) {
                    this.variables1.name = 'identificacion';
                    this.variables1.value = String(this.schedule.identification);
                    this.listVariables.push(this.variables1);
                    this.variables1 = new NameValue();
                  } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.nombre) {
                    this.variables1.name = 'nombre';
                    this.variables1.value = String(this.schedule.name);
                    this.listVariables.push(this.variables1);
                    this.variables1 = new NameValue();
                  } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.telefono) {
                    this.variables1.name = 'telefono';
                    this.variables1.value = String(this.schedule.phone);
                    this.listVariables.push(this.variables1);
                    this.variables1 = new NameValue();
                  }
                });
                this.sendEmail(this.listVariables, 1, this.schedule.email, this.schedule.name, false);
              }
              //this.sendCampaing('','','','','','','','','');
              localStorage.setItem('schedule', JSON.stringify(this.schedule));
              this._router.navigate(['/confirmation']);
            }
          }, 1000);
          localStorage.removeItem('schedule');
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        var circle = new google.maps.Circle(
          { center: geolocation, radius: position.coords.accuracy });
        this.autocomplete.setBounds(circle.getBounds());
      });
    }
  }
  public loadScript(chat: string) {
    if (chat != '') {
      if (chat != null) {
        let body = <HTMLDivElement>document.body;
        let script = document.createElement('script');
        let url = chat.trim();
        script.innerHTML = '';
        script.src = url;
        script.async = true;
        script.defer = true;
        body.appendChild(script);
      }
    }
  }
  loadFile(evt: any) {
    this.scheduleSerie = [];
    const dataFile: any[] = [];
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      for (let i = 7; i < this.data.length; i++) {
        if (this.data[i].length > 0) {
          dataFile.push(this.data[i]);
        }
      }
      for (let j = 0; j < dataFile.length; j++) {
        let temp: any;
        temp = this.buildData(dataFile[j]);
        this.scheduleSerie.push(temp);
        temp = null;
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }
  buildData(arr): ScheduleSerie {
    const temp: ScheduleSerie = new ScheduleSerie();
    for (let k = 0; k < arr.length; k++) {
      temp.id = arr[0];
      temp.scheduleId = 0;
      temp.nit = String(arr[1]);
      temp.datePurchase = new Date(arr[2]);
      temp.mark = String(arr[3]);
      temp.model = String(arr[4]);
      temp.colour = String(arr[5]);
      temp.imei = String(arr[6]);
      temp.cover = String(arr[7]);
      temp.battery = String(arr[8]);
      temp.loader = String(arr[9]);
      temp.memoryRemovable = String(arr[10]);
      temp.freeHand = String(arr[11]);
      temp.other = String(arr[12]);
      temp.failure = String(arr[13]);
      temp.schedule = '';
    }
    return temp;
  }
  reset() {
    this.first = 0;
  }
  getTemplateEmail() {
    this._templateEmailService.getById(1).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.template = response.object;
          this.variables = this.template.variable.split(',');
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  sendEmail(entity, templateId, emailaddress, name, aceptaEnvio) {
    this._emailService.create(entity, templateId, emailaddress, name, aceptaEnvio).subscribe(
      response => {
        if (response.statusCode === '200 OK') {

        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
}
